module.exports = __webpack_public_path__ + "static/media/6 23 '02_4f76b2ef-fe89-4f27-b56f-8559d6dfa264.49e4e8da.png";